import * as React from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as DateHelpers from './DateHelpers';
import JobInfoData from './ScheduleNewJobInfoModal';
import JobScheduleVoidModalData from './JobScheduleVoidModal';

interface JobListProps {
    results: Results[];
    systemCompanyId: number;
    errors: any;
    update(items: Results): void;
    filterDate(filterDate: string, scheduleId: number): void;
}

interface Results {
    itemIndex: number;
    selected: boolean;
    scheduleId: number;
    scheduleDate: string;
    scheduleDateFormatted: string;
    jobQuoteItemId: number;
    jobId: number;
    siteAddress: string;
    customer: string;
    item: string;
    itemShortcut: string;
    type: string;
    quantityType: string;
    hirePeriod: string;
    onoffhireDate: string;
    bringForwardDate: string;
    bringForwardDateFormatted: string;
    notes: string;
    isCustomerPickup: boolean;
}

const JobListData = (props: JobListProps) => {
    const [showJobInfo, setShowJobInfo] = React.useState(false);
    const [showVoidGearList, setShowVoidGearList] = React.useState(false);
    const [scheduleId, setScheduleId] = React.useState(-1);
    const [jobQuoteItemId, setJobQuoteItemId] = React.useState(-1);
    const [scheduleIndex, setScheduleIndex] = React.useState(-1);

    const selectItem = (e: any, index: number) => {
        var results = [...props.results];
        var result = results[index];
        result.selected = e.target.checked;
        props.update(result);
    }

    //grid item changed
    const onCellChange = (index: number, item: string, value: any) => {
        //update item that has changed
        var results = [...props.results];
        var result = results[index];
        let newItem: any = {};
        newItem = result;
        newItem[item] = value;

        props.update(result);
    }

    const showDate = (e: any, index: number) => {
        e.preventDefault();

        var results = [...props.results];
        var result = results[index];

        props.filterDate(result.scheduleDateFormatted, result.scheduleId);
    }

    //SHOW INFO
    const showInfo = (e: any, index: number) => {
        e.preventDefault();
        showInfoModal(index);
    }

    const showInfoModal = (index: number) => {
        var result = props.results[index];
        setScheduleIndex(index);
        setShowJobInfo(true);
        setScheduleId(result.scheduleId);
    }

    const hideJobInfo = () => {
        setShowJobInfo(false);
        setScheduleId(-1);
        setJobQuoteItemId(-1);
        setScheduleIndex(-1);
    }

    const openGearlist = () => {
        var result = props.results[scheduleIndex];
        setJobQuoteItemId(result.jobQuoteItemId);
        setShowJobInfo(false);
        setShowVoidGearList(true);
    }

    const saveJobInfo = () => {
        toast.success("Job Info Saved");
        setShowJobInfo(false);
        setScheduleId(-1);
        setJobQuoteItemId(-1);
        setScheduleIndex(-1);
    }
    //END SHOW INFO

    //VOID GEAR LIST
    const hideVoidGearList = () => {
        setShowVoidGearList(false);
        setShowJobInfo(true);
        setJobQuoteItemId(-1);
    }

    const saveVoidGearList = () => {
        setShowVoidGearList(false);
        setShowJobInfo(true);
        setJobQuoteItemId(-1);
    }
    //END VOID GEARLIST

    var minDate = DateHelpers.addDaysToCurrentDate(-90);
    let jobInfo = <JobInfoData systemCompanyId={props.systemCompanyId} scheduleId={scheduleId} showModal={showJobInfo} hideModal={hideJobInfo} openGearlist={openGearlist} saveModal={saveJobInfo} />
    let editVoidGearlist = <JobScheduleVoidModalData showModal={showVoidGearList} jobQuoteItemId={jobQuoteItemId} hideModal={hideVoidGearList} saveModal={saveVoidGearList} />

    return (
        <div>
            <div className="static-modal">
                {jobInfo}
                {editVoidGearlist}
            </div>
            <div className={props.results.length > 0 ? 'overflowAuto' : 'hidden'}>
                <table className='table tableColours-header'>
                    <thead>
                        <tr>
                            <th className="hidden"></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th>Schedule Date</th>
                            <th>Job Id</th>
                            <th>Site Address</th>
                            <th>Customer</th>
                            <th>Item</th>
                            <th>Quantity</th>
                            <th>Hire Period</th>
                            <th>On/Off Hire</th>
                            <th>Bring Forward</th>
                            <th>Notes</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.results.map((result, index) =>
                            <tr key={index} className={result.type === "Install" && result.isCustomerPickup ? "tableColours--cust--install" : result.type === "Install" ? "tableColours--install" : result.isCustomerPickup ? "tableColours--cust--pickup" : "tableColours--pickup"}>
                                <td className="hidden">{result.scheduleId}</td>
                                <td className="table__text--align">
                                    <div>
                                        <a href="#" onClick={(e) => showInfo(e, index)}>
                                            <span className="fas fa-info-circle copy--icon alignIconCenter tooltipitem tooltipitem__right"><span className="tooltipitemtext tooltipitemtext__right">Booking Information</span></span>
                                        </a>
                                    </div>
                                </td>
                                <td className="table__text--align">{index + 1}</td>
                                <td className="table__text--align"><input type='checkbox' className="input" checked={result.selected} onChange={(e) => selectItem(e, index)} /></td>
                                <td className="table__text--align">
                                    <a href="#" onClick={(e) => showDate(e, index)}>{result.scheduleDate}</a>
                                </td>                                    
                                <td className="table__text--align">
                                    <Link to={'/job/' + result.jobId + '/details'} target="_blank" >
                                        {result.jobId}
                                    </Link>
                                </td>
                                <td className="table__text--align">
                                    <div className="tooltipitem  tooltipitem__right">{result.siteAddress ? result.siteAddress.substring(0, 30) + "... " : ""}
                                        <span className="tooltipitemtext  tooltipitemtext__right">{result.siteAddress}</span>
                                    </div>
                                </td>
                                <td className="table__text--align">{result.customer}</td>
                                <td className="table__text--align">{result.itemShortcut}</td>
                                <td className="table__text--align">{result.quantityType}</td>
                                <td className="table__text--align">{result.hirePeriod}</td>
                                <td className="table__text--align">
                                    <input type="date" min={minDate} className="form-control" value={result.onoffhireDate} onChange={(e) => onCellChange(index, "onoffhireDate", e.target.value)} />
                                </td>
                                <td className="table__text--align">{result.bringForwardDateFormatted}</td>
                                <td className="table__text--align">
                                    <div className="tooltipitem  tooltipitem__left">{result.notes ? result.notes.substring(0, 20) + "... " : ""}
                                        <span className="tooltipitemtext  tooltipitemtext__left">{result.notes}</span>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                {props.errors["results"] ?
                    (props.errors["results"]).split("\n").map((item: any, key: any) => {
                        return <span className="label errors" key={key}>{item}<br /></span>
                    })
                    : ""}
            </div>
            <span className={props.results.length == 0 ? "" : "hidden"}>There were no matching jobs found.</span>
        </div>          
    );
    
}

export default JobListData;